import esAuth from "./esAuth";
import esEntities from "./esEntities";

export default {
    ...esAuth,
    ...esEntities,
    common: {
        yes: "Sí",
        no: "No",
        closePanel: "Cerrar panel",
        resizePanel: "Redimensionar el panel",
        copyMarkdown: "Copiar contenido en Markdown",
        copyMarkdownDone: "Contenido copiado",
        downloadMarkdown: "Descargar en Markdown",
    },
    menu: {
        title: "PM Admin",
        trainings: "Formaciones",
        editMode: "Modo edición",
        categories: "Categorías",
        images: "Imágenes",
        testimonies: "Testimonios",
        trainingVersions: "Versiones",
        darkMode: "Tema",
        signOut: "Cerrar sesión",
    },
    form: {
        delete: "Eliminar",
        cancel: "Cancelar",
        update: "Actualizar",
        create: "Crear",
        back: "Volver",
        edit: "Editar",
        add: "Añadir",
        preview: "Vista previa",
        none: "Ninguno",
        help: "Información",
        reorder: "Reordenar",
        moveItemUp: "Mover hacia arriba",
        moveItemDown: "Mover hacia abajo",
        validate: "Validar",
        emptyList: "Sin elementos",
        noResults: "Sin resultados",
        removeTag: "Quitar",
        validationErrors: "Hay errores en el formulario",
    },
    error: {
        noDataMessage: "Sin datos",
    },
    modal: {
        deleteTitle: "Eliminar elemento",
        deleteMessage: "¿Estás seguro de que quieres eliminar este elemento?",
        unsavedTitle: "Cambios sin guardar",
        unsavedMessage:
            "Tienes cambios sin guardar. ¿Cerrar de todas formas?",
    },
    search: "Buscar",
    action: {
        error: "Ha ocurrido un error",
        createdSuccess: "Creado con éxito",
        createdError: "Error al crear",
        deleteSuccess: "Eliminado con éxito",
        deleteError: "Error al eliminar",
        updateSuccess: "Actualizado con éxito",
        updateError: "Error al actualizar",
    },
    history: {
        title: "Historial",
        tab: {
            versions: "Versiones",
            deleted: "Elementos eliminados",
        },
        empty: "Todavía no hay historial",
        emptyHint:
            "Las creaciones, modificaciones y eliminaciones de este elemento aparecerán aquí, con su autor.",
        loadError: "No se ha podido cargar el historial",
        unknownAuthor: "Autor no identificado",
        emptyValue: "vacío",
        // Un id de relación siempre va acompañado del nombre del elemento al que apunta.
        unknownRecord: "elemento no encontrado",
        deletedRecord: "eliminado",
        today: "Hoy",
        yesterday: "Ayer",
        action: {
            create: "Creación",
            update: "Modificación",
            delete: "Eliminación",
            restore: "Restauración",
            reorder: "Desplazamiento",
        },
        // Resumen alternativo cuando ningún campo ha cambiado.
        summary: {
            create: "Contenido inicial",
            update: "Ningún campo modificado",
            delete: "Elemento eliminado",
            restore: "Estado restaurado",
            reorder: "Posición modificada",
        },
        // Frase de contexto encima del detalle.
        detail: {
            change: "Modificado por {{author}} el {{date}}",
            create: "Contenido en la creación, por {{author}} el {{date}}",
            delete: "Contenido en el momento de la eliminación, por {{author}} el {{date}}",
            restore: "Contenido recreado por {{author}} el {{date}}",
        },
        collection: {
            topics: "Tema",
            topicParts: "Parte",
            topicPartQuestions: "Pregunta",
            testimonies: "Testimonio",
            trainingVersions: "Versión de formación",
        },
        // Etiquetas de los campos técnicos, ausentes de los formularios.
        field: {
            trainingId: "Formación",
            topicId: "Tema",
            topicPartId: "Parte",
            introduction: "Introducción",
            relatedTestimonyIds: "Testimonios relacionados",
            timing: "Duración",
            categoryId: "Categoría",
        },
        compareCurrentToggle: "Comparar con el estado actual",
        compareWithThis: "Comparar con esta versión ({{date}})",
        clearComparison: "Volver a la comparación predeterminada",
        currentState: "El estado actual",
        noDifference: "No hay diferencias entre estos dos estados",
        markupOnly: "solo formato",
        showReorders: "Mostrar los desplazamientos ({{count}})",
        hideReorders: "Ocultar los desplazamientos",
        restore: "Restaurar",
        restoreThisState: "Restaurar este estado",
        restoreVersionOf: "Restaurar el estado del {{date}}",
        confirmRestoreTitle: "Restaurar este estado",
        confirmRestoreMessage:
            "El contenido actual se sustituirá por el de la versión seleccionada. La operación queda registrada en el historial, por lo que podrás volver atrás.",
        confirmRestoreDeletedTitle: "Restaurar este elemento",
        confirmRestoreDeletedMessage:
            "¿Recrear «{{label}}» a partir de su último estado conocido?",
        confirmRestoreDeletedWithChildrenMessage:
            "¿Recrear «{{label}}» a partir de su último estado conocido? También se restaurarán los {{count}} elementos eliminados con él.",
        restoreSuccess: "Estado restaurado",
        restoreSuccessWithChildren:
            "Elemento restaurado, junto con {{count}} elemento(s) relacionado(s)",
        restoreError: "La restauración ha fallado",
        restoreNotRecovered:
            "Algunos contenidos no se han podido recuperar: {{fields}}. Ya no existen.",
        restoreChildrenFailed:
            "{{count}} elemento(s) relacionado(s) no se han podido restaurar.",
        error: {
            parentMissing:
                "El elemento principal ya no existe: restáuralo primero para poder restaurar este.",
            forbidden: "No tienes los permisos necesarios para esta restauración.",
            trainingNotResolved:
                "No se puede vincular este elemento a una formación: su elemento principal probablemente ha sido eliminado. Restaura primero el principal.",
            invalidSnapshot: "Esta versión es ilegible y no se puede restaurar.",
            accountDisabled: "Tu cuenta ha sido desactivada.",
        },
        noDeletedItems: "Ningún elemento eliminado",
        noDeletedItemsHint:
            "Las partes y preguntas eliminadas aparecerán aquí, con la posibilidad de restaurarlas.",
        deletedOn: "eliminado el {{date}}",
        lastSeenOn: "último rastro el {{date}}",
        restored: "Restaurado",
        restoredOn: "restaurado el {{date}} por {{author}}",
        restoredWithParent: "vuelve con su elemento principal",
        limitations:
            "Un elemento creado y eliminado antes de la activación del historial puede no dejar ningún rastro, y las imágenes eliminadas no se pueden recuperar.",
    },
    validation: {
        required: "Este campo es obligatorio",
        url: "Esta URL no es válida",
        integer: "Este valor debe contener solo números",
        requiredMin: "Este campo debe contener al menos {{count}} caracteres",
        requiredMax: "Este campo debe contener máximo {{count}} caracteres",
        arrayRequired: "Se requiere al menos un elemento",
        arrayMin: "Se requieren al menos {{count}} elementos",
        imageValidation: "Se requiere una imagen",
        noNewLines: "Este campo no debe contener nuevas líneas",
    },
};
